import { Helmet } from 'react-helmet-async';
import { Header } from '@/components/layout/Header';
import { Footer } from '@/components/layout/Footer';
import { HolidayHero } from '@/components/holiday/HolidayHero';
import { WhatYouGet } from '@/components/holiday/WhatYouGet';
import { MeetKGOB } from '@/components/holiday/MeetKGOB';
import { TrustStrip } from '@/components/holiday/TrustStrip';

const Holiday = () => {
  return (
    <div className="min-h-screen">
      <Helmet>
        <title>Holiday Money-Saver Kit + Event Invites | KGOB CPAs</title>
        <meta
          name="description"
          content="Get your free Holiday Money-Saver Kit with quick year-end tax moves. Plus, first dibs on Santa events, Coffee Fridays, and Networking Breakfasts from KGOB CPAs."
        />
        <meta name="keywords" content="year-end tax planning, holiday tax tips, KGOB events, tax savings, North Carolina CPA" />
      </Helmet>
      
      <Header />
      
      <main>
        <HolidayHero />
        <WhatYouGet />
        <MeetKGOB />
        <TrustStrip />
      </main>
      
      <Footer />
    </div>
  );
};

export default Holiday;
